import React from 'react';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';
import style from './IsActiveCheckbox.module.scss';

interface IProps {
	isActive: boolean;
}

export const IsActiveCheckbox: React.FC<IProps> = React.memo(({ isActive }) => {
	return (
		<Checkbox className={style.container} checked={isActive} disabled={true}>
			<Text translationNameSpace="form" translationKey="activeLabel" asFragment={true} />
		</Checkbox>
	);
});
